// extracted by mini-css-extract-plugin
export default {"loading-nav":"ioJNkLw8VqlYwm0gNPxu"};